import { DatePicker, DatePickerSelectedValue } from '@storeblocks/datepicker';
import { ChangeEvent, type FC, useState } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { useUserLocale } from '@/i18n/hooks';
import { TrackingElement, useGetTrackId } from '@/tracking';

import { usePresentationContext } from '../PresentationContext';

const dateOfToday = new Date();

export const DateFilter: FC = () => {
  const texts = useTexts();
  const locale = useUserLocale();

  const { globalFilter, setGlobalFilter } = usePresentationContext();
  const [errorMessage, setErrorMessage] = useState('');

  const handleDateOnChange = (
    _: ChangeEvent<HTMLInputElement>,
    selectedDate: DatePickerSelectedValue,
  ): void => {
    // Check if the selected date is empty or invalid and set the
    // error message accordingly.
    if (!selectedDate.isValid || !selectedDate.date) {
      setErrorMessage(texts.pages.presentation.filters.date.error);
    } else {
      setGlobalFilter({
        ...globalFilter,
        date: selectedDate.date,
      });
      setErrorMessage('');
    }
  };

  const getTrackId = useGetTrackId();
  const trackId = getTrackId('select-date', TrackingElement.FilterChip);

  return (
    <DatePicker
      id="presentation-filter-date"
      name="presentation-filter-date"
      selectMonthAriaLabel={texts.datepicker.selectMonthAriaLabel}
      selectYearAriaLabel={texts.datepicker.selectYearAriaLabel}
      labelText={texts.pages.presentation.filters.date.label}
      locale={locale}
      aria-label={texts.pages.presentation.filters.date.label}
      max={dateOfToday}
      data-trackid={trackId}
      alertMessageType={errorMessage ? 'error' : undefined}
      alertMessage={errorMessage}
      data-trackid-source="presentation-filter"
      data-trackid-type="date-picker"
      value={globalFilter.date}
      onChange={handleDateOnChange}
    />
  );
};
